var SlotScene = require('slot-scene').SlotScene;
//
// var SlotWinPresenter = require('slot-win-presenter').SlotWinPresenter;
var SlotWinPresenter = require('derived-slot-win-presenter').DerivedSlotWinPresenter;

var slotConfig = require('cfg/slot-config');

var Commands = require('commands').Commands;
var SmartObject = require('commands').SmartObject;
var Animation = require('animation').Animation;

(function (global) {
    'use strict';

    var MainScene = function (spec, math) {
        SlotScene.call(this, spec, math, slotConfig);

        var self = this;

        this.maingameBackground = new PIXI.Sprite(PIXI.utils.TextureCache["res/mainbackground.jpg"]);
        this.addChild(this.maingameBackground);

        this.freegamesBackground = new PIXI.Sprite(PIXI.utils.TextureCache["res/freegame_background.jpg"]);
        this.addChild(this.freegamesBackground);
        this.freegamesBackground.visible = false;

        this.addChild(this.barrelContainer);

        // массив кодов символов на барабане (нужен для постепенной модификации в минииграх)
        this.symbols = null;

        this.slotPresenter = new SlotWinPresenter(math, slotConfig, this /*delegate*/);
        this.addChild(this.slotPresenter);

        this.slotPresenter.showBarrelElement = function (idx) {
            self.barrel.showSymbolWithIndex(idx);
        };

        this.slotPresenter.hideBarrelElement = function (idx) {
            self.barrel.hideSymbolWithIndex(idx);
        };


        // ТАБЛИЧКИ ФРИГЕЙМОВ

        this.freegamesWinTable = new PIXI.Sprite(PIXI.utils.TextureCache["res/freegames_money_table.png"]);
        this.freegamesWinTable.position.set(0, 0);
        this.addChild(this.freegamesWinTable);
        this.freegamesWinTable.visible = false;

        this.currentWinLabel = new PIXI.extras.BitmapText("", {font: "arial_bold_18", align: "center", tint: 0x412a00});
        this.currentWinLabel.position.set((1024 / 2) - 8, (112 / 2) - 8);
        this.currentWinLabel.anchor.set(0.5, 0.5);
        this.currentWinLabel.visible = false;
        this.freegamesWinTable.addChild(this.currentWinLabel);

        this.freegamesStartTable = new PIXI.Sprite(PIXI.utils.TextureCache["res/freegames_start_table.png"]);
        this.freegamesStartTable.position.set(((1024 - 545) / 2) + 6, ((768 - 260) / 2) - 6);
        this.addChild(this.freegamesStartTable);
        this.freegamesStartTable.visible = false;

        this.freegamesAddTable = new PIXI.Sprite(PIXI.utils.TextureCache["res/freegames_add_table.png"]);
        this.freegamesAddTable.position.set(((1024 - 545) / 2) + 6, ((768 - 260) / 2) - 6);
        this.addChild(this.freegamesAddTable);
        this.freegamesAddTable.visible = false;

        this.freegamesCountLabel = new PIXI.extras.BitmapText("", {font: "arial_bold_18", align: "center", tint: 0x412a00});
        this.freegamesCountLabel.anchor.set(0.5, 0.5);
        this.freegamesCountLabel.position.set((1024 / 2) - 8, (112 / 2) - 8);
        this.freegamesWinTable.addChild(this.freegamesCountLabel);

        this.pressStartLabel = new PIXI.extras.BitmapText("", {font: "arial_bold_18", align: "center", tint: 0x412a00});
        this.pressStartLabel.anchor.set(0.5, 0.5);
        this.pressStartLabel.position.set(137, 205);
        this.pressStartLabel.text = "PRESS START";
        this.freegamesStartTable.addChild(this.pressStartLabel);


        this.freegamesFinishTable = new PIXI.Sprite(PIXI.utils.TextureCache["res/freegames_finish_table.png"]);
        this.freegamesFinishTable.position.set(((1024 - 545) / 2) + 6, ((768 - 260) / 2) - 6);
        this.addChild(this.freegamesFinishTable);
        this.freegamesFinishTable.visible = false;

        // this.totalFreegamesCountLabel = new PIXI.extras.BitmapText("0", {font: "freegametable_font", align: "center"});
        // this.totalFreegamesCountLabel.anchor.set(0.5, 0.5);
        // this.totalFreegamesCountLabel.position.set(620, 57);
        // this.freegamesFinishTable.addChild(this.totalFreegamesCountLabel);

        this.totalFreegamesWinLabel = new PIXI.extras.BitmapText("", {font: "freegamewin-font", align: "center"});
        this.totalFreegamesWinLabel.anchor.set(0.5, 0.5);
        this.totalFreegamesWinLabel.position.set(125, 143);
        this.freegamesFinishTable.addChild(this.totalFreegamesWinLabel);

        this.pressFinishLabel = new PIXI.extras.BitmapText("", {font: "arial_bold_18", align: "center", tint: 0x412a00});
        this.pressFinishLabel.anchor.set(0.5, 0.5);
        this.pressFinishLabel.position.set(137, 205);
        this.pressFinishLabel.text = "PRESS FINISH";
        this.freegamesFinishTable.addChild(this.pressFinishLabel);


        // FREE GAME 1 OF 10 label
        this.freegamesCounterLabel = new PIXI.extras.BitmapText("", {font: "arial_bold_18", align: "center", tint: 0x412a00});
        this.freegamesCounterLabel.anchor.set(0.5, 0.5);
        this.freegamesCounterLabel.position.set((1024 / 2) - 8, (112 / 2) - 8);
        this.addChild(this.freegamesCounterLabel);
        this.freegamesCounterLabel.visible = false;

        this.sndFreegamesMusic = sounds.get("res/sounds/freegame/music");
        this.sndFreegamesMusic.loop(true);
        this.sndFreegamesBegin = sounds.get("res/sounds/freegame/start");
        this.sndFreegamesBegin.loop(false);
        this.sndFreegamesEnd = sounds.get("res/sounds/freegame/end");
        this.sndFreegamesEnd.loop(false);
        this.sndScattersBeforeFree = sounds.get("res/sounds/freegame/scatters");

        this.sndLines = [];
        this.sndLines.push(sounds.get("res/sounds/bet-up"));
        this.sndLines.push(sounds.get("res/sounds/bet-up"));
        this.sndLines.push(sounds.get("res/sounds/bet-up"));
        this.sndLines.push(sounds.get("res/sounds/bet-up"));
        this.sndLines.push(sounds.get("res/sounds/bet-up"));

        this.sndBetUp = sounds.get("res/sounds/bet-up");
        this.sndBetDown = sounds.get("res/sounds/bet-down");

        this.sndCredits = sounds.get("res/sounds/credits");

        this.sndSpin = [];
        this.sndSpin.push(sounds.get("res/sounds/spin/spin_0"));

        this.spinSoundId = 0;

        this.sndReelStop = sounds.get("res/sounds/bar_stop/drum_stop");

        this.sndScatter = [];
        this.sndScatter.push(sounds.get("res/sounds/scatter/scatter_0"));
        this.sndScatter.push(sounds.get("res/sounds/scatter/scatter_1"));
        this.sndScatter.push(sounds.get("res/sounds/scatter/scatter_2"));
        this.sndScatter.push(sounds.get("res/sounds/scatter/scatter_3"));
        this.sndScatter.push(sounds.get("res/sounds/scatter/scatter_4"));

        this.sndSymbols = [];

        // man
        var sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/man_2"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        this.sndSymbols.push(sndTemp);

        // bag
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        this.sndSymbols.push(sndTemp);

        // meshok
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        sndTemp.push(sounds.get("res/sounds/wins/budilnik"));
        this.sndSymbols.push(sndTemp);

        // cent
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        this.sndSymbols.push(sndTemp);

        // wallet
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        this.sndSymbols.push(sndTemp);

        // money
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        sndTemp.push(sounds.get("res/sounds/wins/cent_3"));
        this.sndSymbols.push(sndTemp);

        // A
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/AK_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        this.sndSymbols.push(sndTemp);

        // K
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/AK_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        sndTemp.push(sounds.get("res/sounds/wins/man_3"));
        this.sndSymbols.push(sndTemp);

        // Q
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        this.sndSymbols.push(sndTemp);

        // J
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        this.sndSymbols.push(sndTemp);

        // 10
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        this.sndSymbols.push(sndTemp);

        // 9
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        sndTemp.push(sounds.get("res/sounds/wins/long_pipim"));
        this.sndSymbols.push(sndTemp);

        // scatter
        sndTemp = [];
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        sndTemp.push(sounds.get("res/sounds/wins/win"));
        this.sndSymbols.push(sndTemp);

        this.sndWinflow = sounds.get("res/sounds/winflow");

        this.previousScattersCount = 0;
        this.freegamesMultiplier = spec.specification.freeSpinWinMultiplier;

        var offY = 43;
        var y = 113;
        var x1 = 17;
        var x2 = 800 - x1 - 2;
        var bet = 1;

        this.labelBetL = [];
        this.labelBetR = [];
        for (var i = 0; i < 9; ++i) {

            this.labelBetL.push(new PIXI.extras.BitmapText("", {font: "arial_bold_14", align: "center", tint: 0x000000}));
            this.addChild(this.labelBetL[i]);
            this.labelBetL[i].anchor.set(0.5, 0.5);
            this.labelBetL[i].visible = true;
            this.labelBetL[i].text = "1";

            this.labelBetR.push(new PIXI.extras.BitmapText("", {font: "arial_bold_14", align: "center", tint: 0x000000}));
            this.addChild(this.labelBetR[i]);
            this.labelBetR[i].anchor.set(0.5, 0.5);
            this.labelBetR[i].visible = true;
            this.labelBetR[i].text = "1";
        }

        var k =[3,1,7,5,0,6,8,2,4];
        var l =[0,1,2,5,4,3,6,7,8];
        var r =[0,1,6,5,4,3,2,7,8];
        for (var i = 0; i < 9; ++i) {

            this.labelBetL[k[i]].position.set( x1 * 1.28, (y + offY * l[i]) * 1.28 );
            this.labelBetR[k[i]].position.set( x2 * 1.28, (y + offY * r[i]) * 1.28 );
        }
    };

    MainScene.prototype = Object.create(SlotScene.prototype);//MainScene.prototype = Object.create(Scene.prototype);

    MainScene.prototype.constructor = MainScene;

    MainScene.prototype.update = function (dt, time) {
        // обязательный вызов базовой реализации метода
        SlotScene.prototype.update(dt, time);

        for(var i = 0; i < 9; ++i) {

            this.labelBetL[i].visible = this.slotPresenter._leftBillets[i]._activeBillet.visible;
            this.labelBetR[i].visible = this.slotPresenter._rightBillets[i]._activeBillet.visible;

            this.labelBetL[i].alpha = this.slotPresenter._leftBillets[i]._activeBillet.alpha;
            this.labelBetR[i].alpha = this.slotPresenter._rightBillets[i]._activeBillet.alpha;
        }
    };

    MainScene.prototype.terminate = function () {

        this.slotPresenter.interruptShowWin(this.slotPresenter, this.math);
        this.slotPresenter = null;

        this.sndFreegamesMusic.stop();
        this.sndFreegamesMusic = null;
        this.sndFreegamesBegin.stop();
        this.sndFreegamesBegin = null;
        this.sndFreegamesEnd.stop();
        this.sndFreegamesEnd = null;

        this.sndSymbols.forEach(function(item) {
            item.forEach(function(sound) { sound.stop(); sound = null; });
            item = null;
        });

        if (this.timeoutID) clearTimeout(this.timeoutID);

        this.removeChildren();
        this.destroy();
    };

    MainScene.prototype.setBarrel = function(barrel) {

        SlotScene.prototype.setBarrel.call(this, barrel);

        // определенно невыигрышная ситуация
        // с нее начнется вращение барабанов если сцена восстановится в этом состоянии
        barrel.setCurrentElements([0, 1, 2, 3, 4, 5, 6, 5, 4, 6, 7, 8, 3, 4, 5]);
        barrel.setBlurSpeed(4000);
        barrel.setBlurRotationTime(0.23);
        for (var i = 0; i < 5; ++i) {
            barrel.reels[i].setBlurElements([2,3,4,5,6,7,8,10,11,12]);
        }

        this.barrel.container.visible = true;

    };

    MainScene.prototype.multiplierDidChange = function(newValue, oldValue) {

        for (var i = 0; i < 9; ++i) {

            this.labelBetL[i].text = newValue;
            this.labelBetR[i].text = newValue;
        }

        SlotScene.prototype.multiplierDidChange.call(this, newValue, oldValue);
    };

    MainScene.prototype.onDefaultState = function(lines, multiplier) {

        for (var i = 0; i < 9; ++i) {

            this.labelBetL[i].text = multiplier;
            this.labelBetR[i].text = multiplier;
        }

        SlotScene.prototype.onDefaultState.call(this, lines, multiplier);
    };


    MainScene.prototype.showWin = function(info) {
        SlotScene.prototype.showWin.call(this, info);//this.slotPresenter.showWin(this.slotPresenter, this.math);
    };

    MainScene.prototype.showWinBeforeFreeGames = function(stageMath, done) {
        var onWinShow = function() {
            // RX freeGamesCountIncrease внутри math
            var freeGamesNumber = stageMath.math.freeGamesCountIncrease;
            this.showFreeGamesTable( freeGamesNumber, false, done );
        }.bind(this);

        this.math.spin(stageMath.math.symbols, stageMath.bet.lines, stageMath.bet.multiplier);

        if (this.math.win() > 0) {
            this.slotPresenter.showWinBeforeExtraGames(this.slotPresenter, this.math, onWinShow/*done*/);
            if (this.sndWinflow) this.sndWinflow.play();
        }
        else {
            onWinShow();
        }
    };

    MainScene.prototype.freeShowWinBeforeFreeGames = function(stageMath, done) {
        var onWinShow = function() {
            // RX freeGamesCountIncrease внутри math
            var freeGamesNumber = stageMath.math.freeGamesCountIncrease;
            this.showFreeGamesTable( freeGamesNumber, true, done );
        }.bind(this);

        this.math.freespin(stageMath.math.symbols, stageMath.bet.lines, stageMath.bet.multiplier, this.freegamesMultiplier);

        if (this.math.win() > 0) {
            // this.slotPresenter.showFreeGamesSpinWin(this.slotPresenter, this.math, onWinShow/*done*/);
            this.slotPresenter.showWinBeforeExtraGames(this.slotPresenter, this.math, onWinShow/*done*/);
        }
        else {
            onWinShow();
        }
    };


    MainScene.prototype.freeShowWin = function(info, done) {

        this.math.freespin(info.math.symbols, info.bet.lines, info.bet.multiplier, this.freegamesMultiplier);

        if (this.math.win() > 0) {
            this.slotPresenter.showFreeGamesSpinWin(this.slotPresenter, this.math, done);
            this.flowWin(this.math.win());
        }
        else {
            done();
        }
    };

    MainScene.prototype.scattersDidShow = function(win, first) {

        this.currentWinLabel.text = win + ' CREDITS WON ';
        if (first)
            this.sndScattersBeforeFree.play();
    };

    MainScene.prototype.freeScattersDidHide = function(done) {

        var self = this;

        if (this.previousScattersCount > 2) {
            this.freegamesAddTable.visible = true;
            this.timeoutID = setTimeout(function () {

                self.freegamesAddTable.visible = false;
                done();
            }, 2000);
        }
        else
            done();
    };

    MainScene.prototype.startSpin = function () {

        SlotScene.prototype.startSpin.call(this);

        this.previousScattersCount = 0;

        // this.spinSoundId++;
        // if (this.spinSoundId > 2) {
        //     this.spinSoundId = 0;
        // }

        this.sndSpin[this.spinSoundId].play();
    };

    MainScene.prototype.freeStartSpin = function (currentSpin, totalSpins) {

        this.freegamesWinTable.visible = true;
        this.previousScattersCount = 0;

        this.freegamesCounterLabel.text = "FREE GAME " + currentSpin + " OF " + totalSpins;
        this.freegamesCounterLabel.visible = true;
    };


// реакция на получение данных
    MainScene.prototype.dataDidReceived = function (mathStage) {

        this.symbols = [].concat(mathStage.symbols);
    };


// методы делегата барабана
    MainScene.prototype.barrelDidStop = function () {

        var sound = this.sndSpin[this.spinSoundId];

        var fadeOutTween = new TWEEN.Tween(sound)
            .to({volume: 0}, 200)
            .onComplete(function () {
                sound.stop();
                sound.volume = 1.0;
            })
            .start();
    };

    MainScene.prototype.reelDidStop = function (index) {

        var hasScatterOnReel = false;

        for (var i = index * 3, max = (index + 1) * 3; i < max; ++i) {
            // если на остановившемся колесе есть скаттер
            if (this.symbols[i] === this.math.scatter) {
                hasScatterOnReel = true;
                break;
            }
        }

        if (hasScatterOnReel) {
            // if (index < 3 ||
            //     index === 3 && this.previousScattersCount >= 1 ||
            //     index === 4 && this.previousScattersCount >= 2) {
            //     this.sndScatter[this.previousScattersCount].play();
            // }
            // else {
            //     this.sndReelStop.play();
            // }

            this.sndScatter[this.previousScattersCount].play();
            this.previousScattersCount++;
        }
        else {
            this.sndReelStop.play();
        }
    };

    MainScene.prototype.winFlowComplete = function (interrupt, regularWin) {
        //console.log('FLOW: ', interrupt, regularWin);
        SlotScene.prototype.winFlowComplete.call(this, interrupt);
        if (this.startClock && !interrupt && regularWin) {
            this.startClock();
        }
    };

    MainScene.prototype.lineDidShow  = function (line, win, onFirstTime)
    {
        // this.currentWinLabel.text = 'LINE ' + (line + 1) + ' WINS ' + win;
        this.currentWinLabel.text = win + ' CREDITS WON ';
        // this.currentWinLabel.text = win + ' SCATTERS WON ';
        if (onFirstTime)
        {
            var win_symbol = this.math.lineWinSymbol(line);

            if (typeof this.sndSymbols[win_symbol] !== 'undefined')
            {
                var arrSounds = this.sndSymbols[win_symbol];

                var offset = 3;
                if(arrSounds.length === 4) {

                    offset = 2;
                }

                var win_positions = this.math.lineWinPositions(line);
                var countWinSymbols = win_positions.length - offset;

                arrSounds[countWinSymbols].play();
            }
        }
    };

    /**
     * Делегаты презентера выигрыша
     * */

    MainScene.prototype.winShowDidFinish = function (freegames) {

        if(freegames) {

            var fadeInWidget = this.freegamesCounterLabel;

            if (this.fadeOutWidgetTween) this.fadeOutWidgetTween.stop();

            if (!fadeInWidget.visible) {
                fadeInWidget.visible = true;
                fadeInWidget.alpha = 0;

                this.fadeInWidgetTween = new TWEEN.Tween(fadeInWidget)
                    .to({alpha: 1}, 200)
                    .start();
            }
            else {
                fadeInWidget.alpha = 1;
            }

            var self = this;

            var winLabelTween = new TWEEN.Tween(this.currentWinLabel)
                .to({alpha: 0}, 200)
                .onComplete(function () {
                    self.currentWinLabel.visible = false;
                    self.currentWinLabel.text = "";
                })
                .start();
        }
    };

    MainScene.prototype.showFreeGamesTable = function (increaseNumber, isFreegamesRunning, done) {
        this.freegamesCountLabel.text = "FREE GAME 1 OF " + increaseNumber.toString();
        this.freegamesStartTable.visible = true;
        this.freegamesWinTable.visible = true;

        if (!isFreegamesRunning) {
            this.sndFreegamesBegin.play();

            this.pressStartLabel.alpha = 1;
            this.blinkTween = new TWEEN.Tween(this.pressStartLabel)
                .to({alpha: 0}, 750)
                .repeat(Infinity)
                .delay(100)
                .yoyo(true)
                .easing(TWEEN.Easing.Cubic.InOut)
                .start();
        }
        else {
            this.pressStartLabel.visible = false;
        }

        done();
    };

    MainScene.prototype.hideFreeGamesTable = function (done) {

        if (this.blinkTween) {
            this.blinkTween.stop();
        }

        this.freegamesCountLabel.visible = false;
        this.freegamesStartTable.visible = false;
        this.freegamesWinTable.visible = false;

        this.sndFreegamesBegin.stop();

        done();
    };

    MainScene.prototype.showFreeGamesFinishTable = function(stageMath, lines, multiplier, done) {

        this.sndFreegamesMusic.stop();
        this.sndFreegamesEnd.play();

        // this.totalFreegamesCountLabel.text = stageMath.freeGamesCount.toString();
        this.totalFreegamesWinLabel.text = (stageMath.featureWin * multiplier).toString();

        this.freegamesFinishTable.visible = true;

        this.pressFinishLabel.alpha = 1;
        this.blinkTween = new TWEEN.Tween(this.pressFinishLabel)
            .to({alpha: 0}, 750)
            .repeat(Infinity)
            .delay(100)
            .yoyo(true)
            .easing(TWEEN.Easing.Cubic.InOut)
            .start();

        done();
    };

    MainScene.prototype.hideFreeGamesFinishTable = function (done) {

        this.sndFreegamesEnd.stop();

        this.blinkTween.stop();

        this.freegamesFinishTable.visible = false;
        this.freegamesCounterLabel.visible = false;

        done();
    };

    MainScene.prototype.switchToFreeGames = function (stageMath, done) {

        if (this.sndFreegamesMusic.playing() === false) {
            this.sndFreegamesMusic.play();
        }
    };

    MainScene.prototype.switchToMainGame = function (stageMath, done) {

        this.maingameBackground.alpha = 1.0;
        this.maingameBackground.visible = true;

        this.freegamesWinTable.visible = false;

        this.hideFreeGamesFinishTable(done);

    };

    global.MainScene = MainScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/mainscene.js
// module id = 103
// module chunks = 0